export default "__VITE_PUBLIC_ASSET__71219706__"